// extracted by mini-css-extract-plugin
module.exports = {"profileWrapper":"f_J","avatar":"f_K","socialHeading":"f_L"};